module.exports = __webpack_public_path__ + "img/qrCodeSecond.6347ba82.png";